<template>
  <div>
    <w-scan-condition-box :tab-info="tabInfo" :agent-manager-id="agentManagerId" @change-scan-type="changeScanType" :default-port="defaultPort"
    @change-is-loading="changeIsLoading" @set-table-data="setTableData" @set-agent-status-info="setAgentStatusInfo" :obj-info="objInfo" />
    <w-scan-common-table :tab-info="tabInfo" :scan-type="scanType" :is-loading="isLoading" :table-data="tableData"
    :result-data="resultData" :agent-status="agentStatus" :agent-diff-time="agentDiffTime"/>
  </div>
</template>

<script>
import { isEqual } from 'lodash';
import WScanConditionBox from './ScanConditionBox';
import WScanCommonTable from './ScanCommonTable';

export default {
  name: 'WIpScanTabPanel',
  components: {
    WScanConditionBox,
    WScanCommonTable,
  },
  props: {
    tabInfo: {
      type: Object,
      default: () => {},
    },
    agentManagerId: {
      type: Number,
      default: 0,
    },
    objInfo: {
      type: Object,
      default: () => {},
    },
    defaultPort: {
      type: Number,
    },
  },
  computed: {
    tabName() {
      return this.tabInfo.name;
    },
  },
  data() {
    return {
      scanType: 'SPOT',
      isLoading: false,
      tableData: [],
      resultData: null,
      agentStatus: null,
      agentDiffTime: null,
    };
  },
  methods: {
    changeScanType(scanType) {
      this.scanType = scanType;
    },
    changeIsLoading(isLoading) {
      this.isLoading = isLoading;
    },
    setTableData(tableData) {
      if (isEqual(this.tabName, 'traceroute')) {
        this.resultData = tableData;
      } else {
        this.tableData = tableData;
      }
    },
    setAgentStatusInfo(agentStatus, diffTime) {
      this.agentStatus = agentStatus;
      this.agentDiffTime = diffTime;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/IpScan/components/IpScanTabPanel.vue